export const nav = {
  home: 'Accueil',
  about: 'À Propos',
  booking: 'Réservation & Contact'
};

export const hero = {
  title1: 'Fish Ryders Surfcamp à Imsouane',
  subtitle1: 'Stages de surf tous niveaux et expériences océaniques au Maroc',
  title2: 'Progressez avec Karim coach diplômé Europe',
  subtitle2: "15 ans à Imsouane, 10 ans d'enseignement à Hossegor",
  title3: 'Surf trip et road trip au Maroc',
  subtitle3: 'Les meilleurs spots selon les conditions',
  cta1: 'Demander un trip',
  cta2: 'En savoir plus'
};

export const values = {
  coaching: 'Coaching certifié',
  coachingDesc: 'Moniteurs diplômés Europe avec expérience internationale',
  security: 'Sécurité et pédagogie',
  securityDesc: 'Approche professionnelle adaptée à tous les niveaux',
  spots: 'Spots de renommée mondiale',
  spotsDesc: 'Imsouane et les meilleurs spots de la côte atlantique'
};

export const cta = {
  title: "Prêt à vivre l'expérience Fish Ryders ?",
  subtitle: 'Rejoignez-nous à Imsouane pour des sessions de surf inoubliables encadrées par Karim, coach diplômé avec 15 ans d\'expérience',
  bookNow: 'Réserver maintenant',
  learnMore: 'En savoir plus'
};

export const why = {
  title: 'Pourquoi choisir Fish Ryders ?',
  subtitle: 'Un surfcamp authentique à Imsouane, l\'un des meilleurs spots de surf du Maroc',
  coach: 'Coach Expert',
  coachDesc: 'Karim, 15 ans à Imsouane, diplômé Europe, ancien compétiteur',
  spots: 'Spots Légendaires',
  spotsDesc: 'La Baie et Cathédrale, parmi les meilleures vagues d\'Afrique',
  levels: 'Tous Niveaux',
  levelsDesc: 'Débutants à confirmés, cours individuels ou en groupe',
  experiences: 'Expériences Uniques',
  experiencesDesc: 'Pêche en paddle, surfskate, sorties dunes, road trips'
};

export const footer = {
  description: 'Surfcamp itinérant à Imsouane, Maroc. Stages de surf tous niveaux, coaching certifié et expériences océaniques authentiques.',
  navigation: 'Navigation',
  information: 'Informations',
  home: 'Accueil',
  surfcamp: 'Le Surfcamp',
  imsouane: 'Imsouane',
  stages: 'Stages de Surf',
  activities: 'Activités',
  team: 'Équipe',
  accommodation: 'Logement',
  reservation: 'Réservation',
  contact: 'Contact',
  rights: 'Tous droits réservés.',
  legal: 'Mentions légales',
  privacy: 'Politique de confidentialité',
  poweredBy: 'Powered by Readdy'
};

export const about = {
  badge: 'À Propos',
  title: 'Découvrez Fish Ryders',
  subtitle: 'Surfcamp itinérant à Imsouane, stages de surf tous niveaux et expériences océaniques authentiques au Maroc'
};

export const surfcamp = {
  badge: 'Le Surfcamp',
  title: 'Fish Ryders Surfcamp Itinérant',
  intro: 'Fish Ryders est un surfcamp itinérant basé à Imsouane, ancien village de pêcheurs situé sur la côte Atlantique du Maroc entre Essaouira et Agadir.',
  paragraph1: 'Karim anime les stages de surf et propose aussi de la pêche sportive en paddle, du surfskate et des sorties dans les dunes pour une expérience complète de l\'océan et du désert marocain.',
  paragraph2: 'Notre approche privilégie l\'authenticité, la sécurité et le respect de l\'environnement, dans un cadre exceptionnel où la passion du surf rencontre la culture locale.',
  location: 'Imsouane, Maroc',
  traveling: 'Surfcamp Itinérant',
  allLevels: 'Tous Niveaux'
};

export const imsouane = {
  badge: 'Les Spots',
  title: 'Imsouane et ses vagues légendaires',
  subtitle: 'Découvrez les spots mythiques d\'Imsouane et explorez les meilleurs breaks de la côte atlantique marocaine',
  bayName: 'La Baie',
  bayLevel: 'Débutants & Intermédiaires',
  bayDesc: 'Vague longue et douce, parfaite pour apprendre et progresser en toute sécurité',
  cathedralName: 'La Cathédrale',
  cathedralLevel: 'Avancés & Confirmés',
  cathedralDesc: 'Point break puissant et technique pour surfeurs expérimentés',
  travelingName: 'Sessions Itinérantes',
  travelingLevel: 'Tous Niveaux',
  travelingDesc: 'Déplacements en van vers les meilleurs spots dans un rayon d\'1h selon les conditions',
  longestWaves: 'Les vagues les plus longues d\'Afrique',
  longestWavesDesc: 'Jusqu\'à 800 mètres de glisse sur la Baie d\'Imsouane'
};

export const coach = {
  badge: 'Votre Coach',
  title: 'Karim, expert passionné de l\'océan',
  intro1: 'Originaire de Skhirat au sud de Rabat, Karim surfe à Imsouane depuis 15 ans et connaît chaque vague, chaque courant, chaque secret de ce spot légendaire.',
  intro2: 'Coach de surf chaque été en France depuis 10 ans à Hossegor, il possède les diplômes européens de monitorat de surf et de kitesurf, garantissant un enseignement de qualité internationale.',
  intro3: 'Ancien compétiteur et passionné de pêche, Karim partage sa connaissance approfondie de l\'océan avec authenticité et pédagogie, pour une progression rapide et sécurisée.',
  formerCompetitor: 'Ancien compétiteur',
  europeanDiplomas: 'Diplômes européens surf & kite',
  imsouaneYears: '15 ans à Imsouane',
  hossegorYears: '10 ans à Hossegor'
};

export const stages = {
  badge: 'Stages de Surf',
  title: 'Progressez à votre rythme',
  subtitle: 'Stages et sessions tous niveaux, en individuel ou en groupe, pour tous les âges dans la baie d\'Imsouane et sur les spots réputés de la région',
  privateTitle: 'Cours Individuels',
  privateDesc: 'Coaching personnalisé pour une progression rapide et ciblée',
  groupTitle: 'Cours en Groupe',
  groupDesc: 'Ambiance conviviale et partage entre passionnés',
  roadTripTitle: 'Road Trip',
  roadTripDesc: 'De Skhirat à Taghazout, explorez les meilleurs spots',
  sessionTitle: 'Déroulé d\'une session type',
  step1Title: 'Sécurité',
  step1Desc: 'Briefing complet sur les règles de sécurité et le matériel',
  step2Title: 'Connaissance du plan d\'eau',
  step2Desc: 'Analyse des conditions, courants et zones de surf',
  step3Title: 'Échauffement',
  step3Desc: 'Préparation physique adaptée avant la mise à l\'eau',
  step4Title: 'Lecture des vagues et surf accompagné',
  step4Desc: 'Coaching en temps réel dans l\'eau pour une progression optimale',
  step5Title: 'Compte-rendu et feedback',
  step5Desc: 'Débriefing personnalisé et conseils pour progresser'
};

export const activities = {
  badge: 'Activités',
  title: 'Bien plus que du surf',
  subtitle: 'Une expérience complète entre océan, culture et aventure marocaine',
  surfTitle: 'Surf',
  surfDesc: 'Location de matériel, cours individuels ou en groupe, stages à la semaine',
  fishingTitle: 'Pêche Sportive en Paddle',
  fishingDesc: 'Découvrez la pêche en stand-up paddle avec Karim, passionné de l\'océan',
  surfskateTitle: 'Surfskate',
  surfskateDesc: 'Sessions de surfskate devant la Cathédrale pour améliorer votre technique',
  dunesTitle: 'Sorties Dunes',
  dunesDesc: 'Surf sur sable dans les dunes, tajine de poisson et thé marocain traditionnel'
};

export const team = {
  badge: 'Notre Équipe',
  title: 'Une équipe de passionnés à votre service',
  intro1: 'Notre équipe est composée de passionnés locaux et internationaux, tous unis par l\'amour de l\'océan et du surf.',
  intro2: 'Tous nos moniteurs sont certifiés et possèdent une expertise reconnue en sécurité aquatique, garantissant un encadrement professionnel et rassurant pour tous les niveaux.',
  intro3: 'Nous privilégions une approche humaine et personnalisée, où chaque stagiaire bénéficie d\'une attention particulière pour progresser dans les meilleures conditions.',
  certifiedInstructors: 'Moniteurs certifiés',
  yearsExperience: 'Années d\'expérience'
};

export const accommodation = {
  badge: 'Logement',
  title: 'Trouvez votre hébergement',
  subtitle: 'Le logement est à la charge des stagiaires. Nous vous aidons à trouver l\'hébergement idéal selon vos préférences et votre budget',
  guesthousesTitle: 'Guest Houses',
  guesthousesDesc: 'Hébergements authentiques chez l\'habitant',
  apartmentsTitle: 'Appartements',
  apartmentsDesc: 'Studios et appartements tout équipés',
  hotelsTitle: 'Hôtels',
  hotelsDesc: 'Options confortables pour tous budgets',
  helpTitle: 'Besoin d\'aide pour réserver ?',
  helpDesc: 'Notre équipe vous accompagne dans la recherche et la réservation de votre hébergement à Imsouane. Guest-houses authentiques, appartements confortables ou hôtels, nous connaissons les meilleures adresses du village.',
  askHelp: 'Demander de l\'aide'
};

export const booking = {
  badge: 'Réservation & Contact',
  heroTitle: 'Réservez votre aventure surf',
  heroSubtitle: 'Choisissez votre formule et contactez-nous pour toute question',
  
  // Réservation
  reservationBadge: 'Réservation',
  reservationTitle: 'Réservez votre stage',
  reservationSubtitle: 'Remplissez le formulaire ci-dessous pour réserver votre stage de surf',
  
  lastName: 'Nom',
  firstName: 'Prénom',
  email: 'Email',
  emailPlaceholder: 'votre@email.com',
  phone: 'Téléphone',
  phonePlaceholder: '+212 6XX XXX XXX',
  whatsapp: 'WhatsApp',
  whatsappPlaceholder: '+212 6XX XXX XXX',
  level: 'Niveau de surf',
  selectLevel: 'Sélectionnez votre niveau',
  beginner: 'Débutant',
  initiated: 'Initié',
  intermediate: 'Intermédiaire',
  advanced: 'Avancé',
  confirmed: 'Confirmé',
  formula: 'Formule',
  selectFormula: 'Sélectionnez une formule',
  privateLesson: 'Cours individuel',
  groupLesson: 'Cours en groupe',
  weekStage: 'Stage à la semaine',
  roadTrip: 'Road trip',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  numberOfPeople: 'Nombre de personnes',
  accommodation: 'Hébergement',
  selectAccommodation: 'Sélectionnez un hébergement',
  noAccommodation: 'Non, je gère mon hébergement',
  guesthouse: 'Oui, guesthouse',
  apartment: 'Oui, appartement',
  hotel: 'Oui, hôtel',
  message: 'Message',
  messagePlaceholder: 'Parlez-nous de vos attentes, besoins spécifiques...',
  charactersCount: 'caractères',
  submitReservation: 'Envoyer ma réservation',
  continuePayment: 'Continuer vers le paiement',
  requiredFields: '* Champs obligatoires',
  
  // Contact
  contactBadge: 'Contact',
  contactTitle: 'Contactez-nous',
  contactSubtitle: 'Une question ? Un projet de stage ou de road trip ? N\'hésitez pas à nous contacter',
  fullName: 'Nom complet',
  fullNamePlaceholder: 'Votre nom complet',
  levelPlaceholder: 'Sélectionnez votre niveau',
  desiredDates: 'Dates souhaitées',
  datesPlaceholder: 'Ex: 15-20 juillet 2024',
  yourMessage: 'Votre message',
  messagePlaceholderContact: 'Posez-nous vos questions...',
  sendMessage: 'Envoyer le message',
  sending: 'Envoi en cours...',
  successMessage: 'Message envoyé avec succès !',
  errorMessage: 'Une erreur est survenue. Veuillez réessayer.',
  
  // Informations de contact
  contactInfo: 'Informations de contact',
  meetingPoint: 'Point de rendez-vous',
  surfShop: 'Surfshop centre du village',
  imsouaneAddress: 'Imsouane, Maroc',
  telephone: 'Téléphone',
  emailLabel: 'Email',
  followUs: 'Suivez-nous',
  followUsDesc: 'Rejoignez notre communauté sur les réseaux sociaux pour suivre nos aventures et découvrir nos meilleurs spots'
};

export const legal = {
  title: 'Mentions Légales',
  editorTitle: 'Éditeur du site',
  company: 'Société',
  director: 'Directeur',
  siret: 'SIRET',
  contact: 'Contact',
  hostingTitle: 'Hébergement',
  hostingProvider: 'Hébergeur',
  website: 'Site web',
  propertyTitle: 'Propriété intellectuelle',
  propertyText: 'L\'ensemble du contenu de ce site (textes, images, vidéos, logos) est la propriété exclusive d\'IB CONSEIL ou de ses partenaires. Toute reproduction, distribution, modification ou utilisation sans autorisation préalable est strictement interdite et constitue une contrefaçon sanctionnée par le Code de la propriété intellectuelle.',
  responsibilityTitle: 'Responsabilité',
  responsibilityText: 'IB CONSEIL s\'efforce d\'assurer l\'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, IB CONSEIL ne peut garantir l\'exactitude, la précision ou l\'exhaustivité des informations mises à disposition. En conséquence, IB CONSEIL décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.',
  linksTitle: 'Liens hypertextes',
  linksText: 'Le site peut contenir des liens vers d\'autres sites. IB CONSEIL n\'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu. L\'existence d\'un lien vers un autre site ne constitue pas une validation de ce site ou de son contenu.',
  lawTitle: 'Droit applicable',
  lawText: 'Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d\'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles de compétence en vigueur.'
};

export const privacy = {
  title: 'Politique de Confidentialité',
  introTitle: 'Introduction',
  introText: 'IB CONSEIL, représentée par son directeur Ilan Boutboul, accorde une grande importance à la protection de vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos informations personnelles conformément au Règlement Général sur la Protection des Données (RGPD).',
  collectionTitle: 'Données collectées',
  collectionIntro: 'Nous collectons les données personnelles suivantes lorsque vous utilisez notre site :',
  collectionItem1: 'Informations d\'identité : nom, prénom',
  collectionItem2: 'Coordonnées : adresse email, numéro de téléphone, WhatsApp',
  collectionItem3: 'Informations de réservation : dates, niveau de surf, formule choisie, nombre de personnes',
  collectionItem4: 'Messages et communications que vous nous envoyez',
  useTitle: 'Utilisation des données',
  useIntro: 'Vos données personnelles sont utilisées pour :',
  useItem1: 'Traiter vos demandes de réservation et de contact',
  useItem2: 'Vous fournir les services demandés',
  useItem3: 'Vous envoyer des informations relatives à votre réservation',
  useItem4: 'Améliorer nos services et votre expérience utilisateur',
  protectionTitle: 'Protection des données',
  protectionText: 'Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. Vos données sont conservées de manière sécurisée et ne sont accessibles qu\'aux personnes autorisées.',
  cookiesTitle: 'Cookies',
  cookiesText: 'Notre site utilise des cookies pour améliorer votre expérience de navigation. Les cookies sont de petits fichiers texte stockés sur votre appareil. Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter certaines fonctionnalités du site.',
  rightsTitle: 'Vos droits',
  rightsIntro: 'Conformément au RGPD, vous disposez des droits suivants :',
  rightsItem1: 'Droit d\'accès : vous pouvez demander l\'accès à vos données personnelles',
  rightsItem2: 'Droit de rectification : vous pouvez demander la correction de données inexactes',
  rightsItem3: 'Droit à l\'effacement : vous pouvez demander la suppression de vos données',
  rightsItem4: 'Droit d\'opposition : vous pouvez vous opposer au traitement de vos données',
  rightsContact: 'Pour exercer ces droits, contactez-nous à : contact@fishryders.com',
  contactTitle: 'Contact',
  contactDirector: 'Directeur',
  updatesTitle: 'Modifications',
  updatesText: 'Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications entrent en vigueur dès leur publication sur cette page. Nous vous encourageons à consulter régulièrement cette page pour rester informé de nos pratiques en matière de protection des données.'
};
